<mat-sidenav-container>
   <mat-sidenav style="width:300px;" [mode]="menuMode" [(opened)]="isMenuOpen">
      <asc-menu (itemSelected)="menuItemSelected()"></asc-menu>
   </mat-sidenav>

   <mat-sidenav-content>
      <div class="asc-container">
         @if (!isEmbedded) {
         <mat-toolbar class="asc-main-toolbar" color="primary">
            @if (canShowMenuButton) {
            <button mat-icon-button (click)="openMenu()">
               <mat-icon>menu</mat-icon>
            </button>
            }
            @if (!canShowSettingsPanel && isSettingsPanelVisible) {
            <button mat-icon-button (click)="navigateToSettings()">
               <mat-icon>chevron_left</mat-icon>
            </button>
            }
            <span class="asc-main-toolbar-title">{{title}}</span>

            @if (isAuthenticated)
            {
            <button mat-button class="asc-login-button asc-login-button-text fx-hide-xs" [matMenuTriggerFor]="menu">
               <span class="asc-login-button-content">{{user.displayName}}<br /><small>{{user.userPrincipalName}}</small></span>
               <mat-icon iconPositionEnd>person</mat-icon>
            </button>
            <button mat-icon-button class="asc-login-button fx-hide-gt-xs" [matMenuTriggerFor]="menu">
               <mat-icon>person</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
               <ng-template matMenuContent>
                  <div class="fx-layout-row">
                     <span class="fx-flex"></span>
                     <button mat-button color="primary" (click)="logout()">
                        <span>Abmelden</span>
                     </button>
                  </div>
                  <div class="asc-main-toolbar-menu-panel">
                     <mat-icon>person</mat-icon>
                     <div>
                        <div><b>{{user.displayName}}</b></div>
                        <div class="mat-subtitle-2">{{user.userPrincipalName}}</div>
                     </div>
                  </div>
               </ng-template>
            </mat-menu>
            }
            @else
            {
            <button mat-button class="asc-login-button" (click)="login()">
               <span>Anmelden</span>
            </button>
            }
         </mat-toolbar>
         }

         <asc-notification-bar></asc-notification-bar>

         <div class="asc-routing-outlet" [ngClass]="{'asc-routing-outlet-scroll-overflow': isRoutingOutletHandlingOverflow, 'asc-no-vertical-scrolling': !allowVerticalScrolling}">
            @if (!isProduction) {
            <div class="asc-title-environment">{{environment}}</div>
            }
            <router-outlet></router-outlet>
         </div>

         @if (!isEmbedded) {
         <div class="asc-footer">
            @if (!isDesktopLayout) {
            <p>ARI - ASC {{version}}</p>
            }
         </div>
         }
      </div>

      @if (isBusy)
      {
      <div class="asc-busy-indicator">
         <div class="asc-busy-indicator-control" [ngClass]="{'asc-with-text': busyMessage}">
            <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
            @if (busyMessage)
            {
            <span>{{busyMessage}}</span>
            }
         </div>
      </div>
      }
   </mat-sidenav-content>
</mat-sidenav-container>